
const attachKeyboardInteraction = function(selector) {
  const clickevent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  });

  const els = document.querySelectorAll(selector);

  els.forEach((item) => {
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        item.dispatchEvent(clickevent);
      }
    });
  });
};

export default attachKeyboardInteraction;
